/*
 * Masthead behavior.
 */
var MastheadController = (function ($) {
	
	var win, masthead, popup, mastheadh1, timeout = 2000;
	
	function ready() {
		win = $(window);
		masthead = $("section.content .masthead");
        popup = $(".popup", masthead);
        mastheadh1 = masthead.find("h1");
		
		if (!BreakpointController.isMobile()) {
			setTimeout(show, timeout);
        }
        if (mastheadh1.length > 0 && masthead.length > 0 && (mastheadh1.outerHeight() > masthead.height())) {
            mastheadh1.css("max-width", "90%");
        }
    }
	
	function show() {
		popup.stop(true, true).slideDown(250, 'easeOutQuart');
	}
	
	function hide() {
		popup.stop(true, true).slideUp(250, 'easeOutQuart');
	}
	
	$(ready);
	
})(jQuery);